import { Component, computed, input, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from '@shared/confirmation/confirmation.component';
import { ExperienceStatus } from '@ess-front/shared';
import { ButtonComponent } from '@shared/button/button.component';
import { ButtonClass } from '@shared/button/button-class.type';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { TranslationDomainService } from '@domain/translation-domain.service';

@Component({
  selector: 'ess-open-confirmation',
  templateUrl: './open-confirmation.component.html',
  imports: [ButtonComponent],
})
export class OpenConfirmationComponent {
  status = input.required<ExperienceStatus | null>();
  hash = input.required<string | null>();
  id = input.required<number | null>();
  buttonData: Signal<{ class: ButtonClass; text: string }> = computed(() =>
    this.status() === ExperienceStatus.CONFIRMED
      ? {
          class: '',
          text: this.translationDomainService.translate(marker('experience.openConfirmation')),
        }
      : {
          class: 'inverted',
          text: this.translationDomainService.translate(marker('experience.seeRates&Details')),
        },
  );
  constructor(
    private dialog: MatDialog,
    private translationDomainService: TranslationDomainService,
  ) {}

  openConfirmation(): void {
    this.dialog.open(ConfirmationComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      width: '100vw',
      autoFocus: false,
      data: { id: this.id(), hash: this.hash() },
    });
  }
}
